import e, { forwardRef as o } from "react";
const n = o(function({ testId: a = "fs-loader", variant: t = "dark", ...r }, d) {
  return e.createElement(
    "span",
    { ref: d, "data-fs-loader": !0, "data-fs-loader-variant": t, "data-testid": a, ...r },
    e.createElement("span", { "data-fs-loader-item": !0 }),
    e.createElement("span", { "data-fs-loader-item": !0 }),
    e.createElement("span", { "data-fs-loader-item": !0 })
  );
}), l = n;
export {
  l as default
};
